import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { PerformanceGoal, PerformanceGoalCreate, PerformanceGoalFilter } from '../data/performanceGoal';

export function createPerformanceGoalService(client: AxiosInstance) {
  return createCrudService<PerformanceGoal, PerformanceGoalCreate, PerformanceGoalFilter>(
    client,
    '/hrm/PerformanceGoal',
    'id',
  );
}

export type PerformanceGoalService = CrudService<PerformanceGoal, PerformanceGoalCreate, PerformanceGoalFilter>;
